import React from 'react';

import { IconProps } from '@shared/ui/Icon/model/types';

export const PaperClipIcon = ({ fill = '#818998', width = 11, height = 18 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 11 18"
        fill="none"
    >
        <path
            d="M5.25 18C2.355 18 0 15.645 0 12.75V3.75C0 1.68 1.68 0 3.75 0C5.82 0 7.5 1.68 7.5 3.75V12.75C7.5 13.9875 6.4875 15 5.25 15C4.0125 15 3 13.9875 3 12.75V4.5H4.5V12.75C4.5 13.1625 4.8375 13.5 5.25 13.5C5.6625 13.5 6 13.1625 6 12.75V3.75C6 2.5125 4.9875 1.5 3.75 1.5C2.5125 1.5 1.5 2.5125 1.5 3.75V12.75C1.5 14.82 3.18 16.5 5.25 16.5C7.32 16.5 9 14.82 9 12.75V2.25H10.5V12.75C10.5 15.645 8.145 18 5.25 18Z"
            fill={fill}
        />
    </svg>
);
